// ---- Navbar scroll behavior ----
    (function () {
      var scrollTop = document.getElementById('scroll-top');

      function onScroll() {
        var y = window.scrollY;

        // The header is static: it stays fixed at the top at full height at
        // all times. The shrink-on-scroll (.scrolled) and hide-on-scroll-down
        // (.nav-hidden) toggles were removed, so neither class is ever
        // applied and the bar never moves or resizes. Only the scroll-to-top
        // button still responds to scroll position.

        if (y > 400) {
          scrollTop.classList.add('visible');
        } else {
          scrollTop.classList.remove('visible');
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      scrollTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }());

    // ---- Hero carousel (background-only cross-fade) ----
    (function () {
      var root = document.getElementById('hero-carousel');
      if (!root) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
      var dotsWrap = document.getElementById('hero-dots');
      var controls = document.getElementById('hero-controls');
      var prevBtn = document.getElementById('hero-prev');
      var nextBtn = document.getElementById('hero-next');
      var hero = document.getElementById('hero');
      var INTERVAL = 6000;
      var timer = null;
      var index = 0;

      // Drop any slide whose image file failed to load, so missing
      // placeholder filenames never show as blank frames.
      function prune(cb) {
        var pending = slides.length;
        if (!pending) { cb(); return; }
        slides.slice().forEach(function (img) {
          function settle(ok) {
            if (!ok) {
              img.parentNode && img.parentNode.removeChild(img);
              var i = slides.indexOf(img);
              if (i !== -1) slides.splice(i, 1);
            }
            if (--pending === 0) cb();
          }
          if (img.complete) {
            settle(img.naturalWidth > 0);
          } else {
            img.addEventListener('load', function () { settle(true); });
            img.addEventListener('error', function () { settle(false); });
          }
        });
      }

      function build() {
        if (slides.length <= 1) {
          hero.classList.add('hero-carousel-single');
          if (slides[0]) slides[0].classList.add('is-active');
          return;
        }

        // Build a dot per slide
        slides.forEach(function (s, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(dot);
        });

        prevBtn.addEventListener('click', function () { go(index - 1); restart(); });
        nextBtn.addEventListener('click', function () { go(index + 1); restart(); });

        // Pause auto-advance while the pointer is over the hero
        hero.addEventListener('mouseenter', stop);
        hero.addEventListener('mouseleave', start);

        go(0);
        start();
      }

      function go(n) {
        var count = slides.length;
        index = (n % count + count) % count;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === index);
        }
      }

      function start() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = window.setInterval(function () { go(index + 1); }, INTERVAL);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      prune(build);
    }());

    // ---- Mobile hamburger menu ----
    (function () {
      var hamburger  = document.getElementById('hamburger');
      var mobileNav  = document.getElementById('mobile-nav');
      var closeBtn   = document.getElementById('mobile-nav-close');
      var mobileLinks = document.querySelectorAll('.mobile-link');

      function openNav() {
        mobileNav.classList.add('open');
        mobileNav.style.display = 'flex';
        hamburger.classList.add('open');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeNav() {
        mobileNav.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () {
          if (!mobileNav.classList.contains('open')) {
            mobileNav.style.display = 'none';
          }
        }, 350);
      }

      hamburger.addEventListener('click', function () {
        if (mobileNav.classList.contains('open')) {
          closeNav();
        } else {
          openNav();
        }
      });

      closeBtn.addEventListener('click', closeNav);

      mobileLinks.forEach(function (link) {
        link.addEventListener('click', closeNav);
      });

      // Close on ESC
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeNav();
      });
    }());

    // ---- Lazy image error fallback cleanup ----
    // Images with onerror handlers manage their own fallback.
    // This script ensures category card placeholders are positioned correctly.
    (function () {
      var cards = document.querySelectorAll('.category-card');
      cards.forEach(function (card) {
        var ph = card.querySelector('.img-placeholder');
        if (ph) {
          ph.style.position = 'absolute';
          ph.style.top = '0';
          ph.style.left = '0';
          ph.style.width = '100%';
          ph.style.height = '100%';
        }
      });
    }());
  
    /* ===========================
       SCROLL REVEAL
       Elements are only hidden once JS confirms IntersectionObserver works,
       so content never gets stranded invisible.
    =========================== */
    (function () {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var GROUPS = [
        '.section-label', '.section-title', '.section-intro',
        '.about-text', '.about-image-frame', '.about-fact',
        '.contact-panel', '.category-card', '.event-card', '.testimonial-card',
        '.vendors-text', '.vendors-image-frame',
        '.auctions-inner > *', '.find-us-info', '.map-placeholder',
        '.auction-partner'
      ];

      var nodes = [];
      GROUPS.forEach(function (sel) {
        Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
          if (el.closest('#hero')) return;          // hero is above the fold
          if (nodes.indexOf(el) !== -1) return;     // no double-registering
          nodes.push(el);
        });
      });

      // Stagger siblings so grids cascade instead of popping in together.
      nodes.forEach(function (el) {
        var parent = el.parentNode;
        if (!parent.__revealIndex) parent.__revealIndex = 0;
        var i = parent.__revealIndex++;
        el.style.transitionDelay = Math.min(i, 5) * 80 + 'ms';
        el.classList.add('reveal');
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);               // reveal once, then stop
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      nodes.forEach(function (el) { io.observe(el); });
    })();

    /* ---------------------------------------------------------------
       CONTACT FORM
       No backend: hand the message off to the visitor's mail client.
       Swap in a real endpoint (action/method on the <form>) and delete
       this block when a form service is wired up.
    --------------------------------------------------------------- */
    (function () {
      var form   = document.getElementById('contact-form');
      var status = document.getElementById('contact-form-status');
      if (!form) return;

      var TO = 'info@earlyowego.com';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var name    = form.elements['name'].value.trim();
        var email   = form.elements['email'].value.trim();
        var phone   = form.elements['phone'].value.trim();
        var topic   = form.elements['topic'].value;
        var message = form.elements['message'].value.trim();

        if (!name || !email || !message) {
          status.textContent = 'Please fill in your name, email, and message.';
          return;
        }

        var body = [
          'Name: ' + name,
          'Email: ' + email,
          phone ? 'Phone: ' + phone : null,
          'Topic: ' + topic,
          '',
          message
        ].filter(Boolean).join('\n');

        window.location.href = 'mailto:' + TO +
          '?subject=' + encodeURIComponent('Website inquiry — ' + topic) +
          '&body=' + encodeURIComponent(body);

        status.textContent = 'Opening your email app… if nothing happens, write to ' + TO + '.';
      });
    })();
